import { Button, alpha } from '@mantine/core';
import { FC, useState } from 'react';

import { Option } from '@/models/Option.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    option: Option;
    selectedOption?: string;
    onSelectHandler: (option: Option) => void;
    classNames?: {
        option?: string;
    };
}

const ButtonOption: FC<Props> = ({ option, selectedOption, onSelectHandler, classNames }) => {
    const [is_hovered, setIsHovered] = useState(false);
    const custom_color = option.color ? alpha(option.color, selectedOption === option.id ? 0.8 : 0.3) : undefined;
    const hover_color = option.color ? alpha(option.color, 0.6) : undefined;

    return (
        <Button
            onClick={() => onSelectHandler(option)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            key={option.id}
            variant="default"
            classNames={{ label: 'w-full justify-center' }}
            className={cn(
                'h-10 rounded-lg px-2 font-medium',
                selectedOption === option.id &&
                    'border-green border-2 border-green-300 bg-green-300 bg-opacity-30 hover:bg-green-300 hover:bg-opacity-30',

                classNames?.option
            )}
            style={
                // Only if calendar has color, otherwise it will use className fallback
                option.color && option.color !== '#ffffff'
                    ? {
                          border: `2px solid ${option.color}`,
                          backgroundColor: is_hovered ? hover_color : custom_color,
                      }
                    : undefined
            }
        >
            {option.label}
        </Button>
    );
};

export default ButtonOption;
